module.exports = __webpack_public_path__ + "img/hr-ccm-universal-04c-wire-sequence.6beb268a.png";